import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { CustomInput, FormText } from 'reactstrap'
import { format } from 'date-fns'

import DateTimePicker from '~/components/DateTimePicker'
import Field from './Field'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

function PostDateRangeField({ setShowHours, initialValue }) {
  const [enableTime, setEnableTime] = useState(false)
  const startPickerRef = useRef()
  const endPickerRef = useRef()

  useEffect(() => {
    if (!initialValue?.hasTime) return

    setEnableTime(true)
  }, [initialValue])

  return (
    <div>
      <PostDateRangeField.DatesContainer>
        <Field
          name="event.schedule.startDateTime"
          label="Start date"
          render={props => <DateTimePicker ref={startPickerRef} {...props} />}
          options={{ enableTime }}
          onChange={(value, helpers) => {
            if (!value?.[0]) return
            const iso = format(value?.[0], "yyyy-MM-dd'T'hh:mm")
            helpers.setValue(iso)
          }}
          enableBlurAction={false}
          showIcon
          required
        />

        <Field
          name="event.schedule.endDateTime"
          label="End date"
          render={props => <DateTimePicker ref={endPickerRef} {...props} />}
          options={{ enableTime: enableTime }}
          onChange={(value, helpers) => {
            if (!value?.[0]) return
            const iso = format(value?.[0], "yyyy-MM-dd'T'hh:mm")
            helpers.setValue(iso)
          }}
          enableBlurAction={false}
          showIcon
          required
        />
      </PostDateRangeField.DatesContainer>

      <CustomInput
        className="mt-1"
        id="switch-enable-post-time locasty-switch-sm"
        bsSize="sm"
        type="switch"
        style={{ zIndex: '0 !important' }}
        checked={enableTime}
        onChange={e => {
          startPickerRef.current.flatpickr.set('enableTime', e.target.checked)
          endPickerRef.current.flatpickr.set('enableTime', e.target.checked)
          setEnableTime(e.target.checked)
          setShowHours(e.target.checked)
        }}
        inline
      >
        <span>
          <FormattedMessage id="Add time" />{' '}
          <FormText className="text-bold-500 d-inline-block">
            <FormattedMessage
              id={
                enableTime
                  ? 'Choose the time on the calendar above'
                  : 'Activate to show the time on the calender'
              }
            />
          </FormText>
        </span>
      </CustomInput>
    </div>
  )
}

PostDateRangeField.DatesContainer = styled.div`
  display: flex;
  gap: 20px;

  @media ${queries.less.sm} {
    flex-direction: column;
  }
`

export default PostDateRangeField
